// brightresolve_app/src/components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { authState } = useAuth();
  const { isAuthenticated, loading, initialized } = authState;
  const location = useLocation();

  if (!initialized || loading) {
    // Keep private content fail-closed without replacing the whole product
    // with a branded restoration page during an ordinary cookie check.
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
